import React from 'react';
import { useTranslation } from 'react-i18next';

const Login = () => {
  const { t } = useTranslation();
  const handleInstall = () => {
    const base = (import.meta.env.VITE_BACKEND_URL || '').replace(/\/$/, '');
    window.location.href = base ? `${base}/install` : '/install';
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img
          src={`${import.meta.env.BASE_URL}quote2cart_long_logo.png`}
          alt="Quote2Cart"
          className="login-logo mb-3"
        />
        <p className="text-muted">{t('login.subtitle')}</p>
        <button className="install-button" onClick={handleInstall}>
          {t('login.installApp')}
        </button>
      </div>
    </div>
  );
};

export default Login;
